import Link from 'next/link';
import React from 'react';
import { Controller } from '../../svg/scholarships/Controller';
import { DollarCardHead } from './DollarCardHead';

type Props = {
    dark: boolean;
    description: string;
    tagline: string;
    buttonText: string;
    buttonLink: string;
    imageSrc: string;
    width: number;
    height: number;
    needsPadd: boolean;
};

export const DollarCard: React.FC<Props> = ({
    dark,
    tagline,
    description,
    buttonText,
    buttonLink,
    imageSrc,
    width,
    needsPadd,
    height,
}) => {
    return (
        <div className={`dollar-card`}>
            <div className={`card-head${dark ? ' dark' : ''}`}>
                <DollarCardHead
                    imageSrc={imageSrc}
                    altText={'Logo'}
                    width={width}
                    height={height}
                    needsPadding={needsPadd}
                />
            </div>
            <div className="card-body">
                <p className="card-tagline">{tagline}</p>
                <p className="card-description">{description}</p>
                <Link href={buttonLink}>
                    <a className="button green-button large-button">{buttonText}</a>
                </Link>
            </div>
        </div>
    );
};
